export default __webpack_public_path__ + "static/media/assorted-clump-play.00b1e04e.png";